import React, { useState } from 'react'
import { MainContainer } from '../Components/Elements'
import PagesNav from '../Components/PagesNav'
import { Modal, Offcanvas, Pagination, Table } from 'react-bootstrap'
import SearchInput from '../Components/SearchInput'
import AddInput from '../Components/AddInput'
import MainInput from '../Components/MainInput'
import NotificationsCenterHooks from '../hooks/NotificationsCenterHooks'
import NoData from '../Components/NoData'
import Shimmer from '../Components/Shimmer'

const NotificationsCenter = () => {

    const {
        NavItems,
        laoding,
        allNotifications,
        handlePageChange,
        getPageNumbers,
        totalPages,
        currentPage,
        showImage,
        handleCloseImage,
        clicklImage,
        image
      } = NotificationsCenterHooks()


    
      return <>
      <MainContainer>
        <div className='d-flex mb-3 align-items-center'>
        <PagesNav links={NavItems}/>
        </div>
    
        <Table hover className='text-center'>
          <thead >
            <tr>
              <th className='bg-light'>Title </th>
              <th className='bg-light'>Body</th>
              <th className='bg-light'>Image</th>
            </tr>
          </thead>
          <tbody>
         {laoding ? (
              Array.from({ length: 5 }, (_, index) => (
                <Shimmer key={index} type={"table"} colSpan={7} />
              ))
            ) : allNotifications.length > 0 ?  allNotifications.map((notification , index)=>  <tr key={index}>
            <td>{notification?.title}</td>
            <td>{notification?.body}</td>
            <td><i onClick={()=>{clicklImage(notification?.image)}} className="fa-regular fa-image fs-4 cursor-pointer"></i></td>
          </tr>) :<td colSpan={3}>
                <NoData />
              </td>}
           
          </tbody>
        </Table>
        {allNotifications.length > 0 && (
          <div className="d-flex justify-content-center mt-3">
            <Pagination>
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {getPageNumbers().map((pageNumber) => (
                <Pagination.Item
                  linkClassName="bg-white text-black"
                  key={pageNumber}
                  active={pageNumber === currentPage}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        )}
      </MainContainer>
      <Modal show={showImage} onHide={handleCloseImage} centered>
        <Modal.Body><img src={image} alt='Image' className='w-100'/></Modal.Body>
      </Modal>
    
      </>
}

export default NotificationsCenter